import { Component, AfterViewInit } from '@angular/core';
import { HttpService,HttpCall } from '../http-service.service';

@Component({
  selector: 'app-lista3',
  templateUrl: './lista3.component.html',
  styleUrls: ['./lista3.component.scss']
})
export class Lista3Component implements AfterViewInit {
  loading:boolean = true;
  dati:any[] = null

  constructor(private httpService:HttpService) { }

  ngAfterViewInit() {
    this.refresh();
  }
  
  refresh() {
    this.loading=true;
    let call:HttpCall = {url: "enduser/storico"}

    this.httpService.GetJSONContent<any>(call).subscribe(response => {
      this.dati=response.body;
    },(e)=>{this.loading=false},()=>{this.loading=false});
  }


}
